export const getClientSearchParams = (fallback: string) => {
  if (typeof window === 'undefined') {
    return new URLSearchParams(fallback);
  }

  return new URLSearchParams(window.location.search);
};

export const syncListingSearchParams = (queryString: string) => {
  const { pathname } = window.location;
  const url = queryString ? `${pathname}?${queryString}` : pathname;

  window.history.replaceState(window.history.state, '', url);
};
